module.exports = __webpack_public_path__ + "img/mesa_el_t.b8529954.png";